
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hygen component template`}</h1>
    <p>{`A simple component generator. Creates a functional or class component along with an optional static js file and docs structure`}</p>
    <h2>{`Simple usage`}</h2>
    <h3>{`Generate`}</h3>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`$ npm install hygen -g`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$ cd src/components`}</inlineCode></li>
      <li parentName="ol"><inlineCode parentName="li">{`$ hygen component new`}</inlineCode></li>
      <li parentName="ol">{`Answer questions`}</li>
      <li parentName="ol">{`New component will be created in `}<inlineCode parentName="li">{`src/components`}</inlineCode></li>
    </ol>
    <h3>{`Use`}</h3>
    <p>{`After you generated your new component, there are few things which are not automated.`}</p>
    <ol>
      <li parentName="ol">{`Component should be exportable from `}<inlineCode parentName="li">{`src/components/index.js`}</inlineCode></li>
      <li parentName="ol">{`If you created optional static js file, you should initialise it inside `}<inlineCode parentName="li">{`src/components/static.js`}</inlineCode>{` file, `}<br />{`the initialisation should correspond to documentation section named `}<strong parentName="li">{`Custom initialisation`}</strong></li>
    </ol>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;